import { azureVMAvailabilityGuideMetadata } from './azure-vm-availability-guide';
import { azsizeCLIGuideMetadata } from './azsize-cli-guide';

export const blogPosts = [
  azureVMAvailabilityGuideMetadata,
  azsizeCLIGuideMetadata
];
